(function containerTypeAssociateMetadataControllerDefinition() {
    'use strict';

    angular.module('ContainerType')
        .controller('ContainerTypeAssociateDocumentTypeController', [
            '$scope', 'config', '$state', '$filter', '$translate', '$stateParams', '$uibModal', '$q', 'errorsExtend', 'adminContainerTypeService', 'adminDocumentTypeService', 'authExtend',
            function containerTypeAssociateDocumentTypeController($scope, config, $state, $filter, $translate, $stateParams, $modal, $q, errors, adminContainerTypeService, adminDocumentTypeService, authExtend) {
                $scope.models = {
                    selected: null,
                    source: null,
                    associated: [],
                    disabled: [],
                    availables: []
                };

                $scope.documentType = {
                    documentTypeName: null,
                    documentType: null,
                    documentContainer: null,
                    id: null
                };

                adminContainerTypeService.getById($stateParams.id, 'Detail').then(function (result) {
                    if (!authExtend.isInRole('CONFIG ADMIN APPS') && !authExtend.isInRole('CONTAINERTYPE WRITE') && result.applicationId !== config.appId()) {
                        errors.showError("forbidden");
                        $state.go('container-type-find');
                    }

                    $scope.containerType = result;
                    $scope.containerType.hasAssociatedDocument = $scope.containerType.documentTypes.length > 0;

                    result.documentTypes.forEach(function (dt) {
                        if (dt.enabled) {
                            $scope.models.associated.push(dt);
                        }
                        else {
                            $scope.models.disabled.push(dt);
                        }
                    });
                }, function (error) {
                    errors.showError(error);
                    $state.go('container-type-find');
                }).then(function () {
                    adminDocumentTypeService.get().then(function (result) {
                        result.forEach(function (dt) {
                            var docTypeFound = $filter('filter')($scope.containerType.documentTypes, { documentTypeId: dt.id }, true);
                            if (docTypeFound.length == 0) {
                                var item = {};
                                item.documentTypeName = dt.name,
                                    item.documentTypeId = dt.id
                                $scope.models.availables.push(item);
                            }
                        });
                    });
                });

                $scope.moveFromAssociated = function (item, index) {
                    $scope.models.associated.splice(index, 1);
                    if (item.isNew) {
                        $scope.models.availables.splice(item.previousIndex, 0, item);
                    }
                    else {
                        $scope.models.disabled.push(item);
                    }
                }

                $scope.moveFromDisabledRight = function (item, index) {
                    $scope.models.disabled.splice(index, 1);
                    if (item.previousIndex != undefined) {
                        $scope.models.availables.splice(item.previousIndex, 0, item);
                    }
                    else {
                        $scope.models.availables.push(item);
                    }
                }

                $scope.moveFromDisabledLeft = function (item, index) {
                    $scope.models.disabled.splice(index, 1);
                    $scope.models.associated.push(item);
                    return $scope.postProcess(item, index);
                }

                $scope.moveFromAvailable = function (item, index) {
                    item.isNew = true;
                    item.previousIndex = index;
                    $scope.models.availables.splice(index, 1);
                    $scope.models.associated.push(item);
                    return $scope.postProcess(item, 0);
                }


                $scope.getIndex = function (item, list) {
                    for (var i = 0; list.length > i; i++) {
                        if (item.documentTypeId === list[i].documentTypeId)
                            return i;
                    }

                    return -1;
                }

                $scope.validateAction = function (event, index, item) {
                    var currentSource = $scope.models.source;
                    var currentTarget = event.target.parentElement.attributes['dnd-list'].value;
                    $scope.models.source = null;

                    if (!$scope.containerType.hasAssociatedDocument || item.isNew) {
                        if (currentTarget === 'models.associated') {
                            if (currentSource === 'models.availables') {
                                item.previousIndex = $scope.getIndex(item, $scope.models.availables);
                                item.isNew = true;
                            }
                            return $scope.postProcess(item, index);
                        } else {
                            return item;
                        }
                    }

                    if (currentTarget === 'models.availables') {
                        return false;
                    }

                    if (currentSource === 'models.availables') {
                        item.previousIndex = $scope.getIndex(item, $scope.models.availables);
                        item.isNew = true;
                    }

                    if (currentTarget === 'models.associated') {
                        return $scope.postProcess(item, index);
                    }

                    return item;
                };

                $scope.removeItem = function (source, index) {
                    source.splice(index, 1);
                };

                $scope.setSource = function (event) {
                    $scope.models.source = event.target.parentElement.attributes['dnd-list'].value;
                };
                $scope.cancel = function () {
                    $state.go('container-type-find');
                };

                $scope.save = function () {
                    $scope.containerType.documentTypes = [];

                    $scope.models.associated.forEach(function (dt) {
                        dt.enabled = true;
                        $scope.containerType.documentTypes.push(dt);
                    });

                    $scope.models.disabled.forEach(function (dt) {
                        dt.enabled = false;
                        $scope.containerType.documentTypes.push(dt);
                    });

                    return adminContainerTypeService.modify($scope.containerType).then(function () {
                        $state.go('container-type-find');
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };

                function setValue(scope, property, value) {
                    if (value) {
                        $q.when(value).then(function (val) {
                            scope[property] = val;
                        });
                    }
                }

                var modalController = function ($scope, $modalInstance, $translate, info) {
                    setValue($scope, 'title', info.name);
                    $scope.item = info;

                    $scope.showAsName = true;
                    if (!$scope.item.name) {
                        for (var i = 0; i < $scope.item.associated.length; i++) {
                            if ($scope.item.associated[i].name) {
                                $scope.showAsName = false;
                                break;
                            }
                        }
                    }

                    $scope.setRequired = function () {
                        $scope.item.enabled = "1";
                    }

                    $scope.unSetAsMetadata = function () {
                        $scope.item.name = "0";
                    }

                    $scope.ok = function () {
                        $modalInstance.close($scope.item);
                    };
                };
                modalController.$inject = ['$scope', '$modalInstance', '$translate', 'info'];

                function openModal(item, associated) {
                    var modalInstance = $modal.open({
                        templateUrl: '/app/views/container-type/partial-document-type-association.html',
                        controller: modalController,
                        size: 'md',
                        resolve: {
                            info: function () {
                                return {
                                    name: item.documentTypeName,
                                    enabled: item.enabled,
                                };
                            }
                        }
                    });

                    var result = modalInstance.result;
                    return result;
                }

                function openCardinalityModal(item, associated) {
                    var modalInstance = $modal.open({
                        templateUrl: '/app/views/container-type/partial-cardinality.html',
                        controller: cardinalityModalController,
                        size: 'md',
                        resolve: {
                            info: function () {
                                return {
                                    docTypeName: item.documentTypeName,
                                    maxDocumentsForContainerType: item.maxDocumentsForContainerType,
                                    maxContainersForDocumentType: item.maxContainersForDocumentType,
                                };
                            }
                        }
                    });
                    var result = modalInstance.result;
                    return result;
                }

                var cardinalityModalController = function ($scope, $modalInstance, $translate, info) {
                    setValue($scope, 'title', info.name);
                    $scope.item = info;
                    $scope.canClose = true;

                    $scope.ok = function () {
                        $scope.control($scope.item.maxDocumentsForContainerType, $scope.item.maxContainersForDocumentType);
                        if ($scope.canClose)
                            $modalInstance.close($scope.item);
                    };
                    $scope.cancel = function () {
                        $modalInstance.close();
                    }

                    $scope.control = function (num1, num2) {
                        $scope.canClose = ((num1 % 1 === 0) || num1 == null) && ((num2 % 1 === 0) || num2 == null);
                    }
                };
                cardinalityModalController.$inject = ['$scope', '$modalInstance', '$translate', 'info'];

                $scope.resetCardinality = function (item, index) {
                    var currentItem = $scope.models.associated[index];
                    currentItem.maxContainersForDocumentType = null;
                    currentItem.maxDocumentsForContainerType = null;
                }

                $scope.postProcess = function (item, index) {
                    var oldIndex = $scope.getIndex(item, $scope.models.associated);
                    if (oldIndex >= 0 && index > oldIndex) {
                        //le saco una pos, porque cuenta su viejo registro.
                        index--;
                    }

                    // CSPROD-3410 : Remove this modal when asociate
                    //openModal(item, $scope.models.associated).then(function (result) {
                    //    var currentItem = $scope.models.associated[index];
                    //    currentItem.enabled = result.enabled === true || result.enabled === '1';

                    //    currentItem.containerTypeId = $stateParams.id;
                    //    if (currentItem.id === 0) {
                    //        currentItem.id = null;
                    //    }
                    //});

                    return item;
                };

                $scope.modifyCardinality = function (item, index) {
                    openCardinalityModal(item, index).then(function (result) {
                        var currentItem = $scope.models.associated[index];
                        currentItem.maxContainersForDocumentType = result.maxContainersForDocumentType;
                        currentItem.maxDocumentsForContainerType = result.maxDocumentsForContainerType;
                    });
                }
            }
        ]);
})();